import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocError(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M77 19.5H20.125c-4.487 0-8.125 3.582-8.125 8h56.875c0-4.418 3.638-8 8.125-8Z"
        fill="#E2E8F0"
      />
      <path
        d="M28.111 92.4c0 4.474 3.632 8.1 8.111 8.1H93c-4.48 0-8.111-3.626-8.111-8.1V27.6c0-4.474-3.632-8.1-8.111-8.1H20c4.48 0 8.111 3.627 8.111 8.1v64.8Z"
        fill="#F1F5F9"
      />
      <path d="M85 85.5V35.669L28 27.5v49.831L85 85.5Z" fill="#F1F5F9" />
      <path
        d="M27.2 92.5V27.611c0-4.048-3.234-7.311-7.2-7.311a.8.8 0 1 1 0-1.6c4.87 0 8.8 4 8.8 8.911V92.5a.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M36 100.5h56.875c4.487 0 8.125-3.582 8.125-8H44.125c0 4.418-3.638 8-8.125 8Z"
        fill="#CCD5E1"
      />
      <path
        d="M77 76.7a.8.8 0 1 1 0 1.6H48a.8.8 0 1 1 0-1.6h29Zm0-6.6a.8.8 0 0 1 0 1.6H48a.8.8 0 0 1 0-1.6h29Zm0-6.6a.8.8 0 0 1 0 1.6H48a.8.8 0 1 1 0-1.6h29Zm0-6.6a.8.8 0 1 1 0 1.6H48a.8.8 0 0 1 0-1.6h29Zm0-6.6a.8.8 0 0 1 0 1.6H48a.8.8 0 0 1 0-1.6h29Zm0-6.6a.8.8 0 1 1 0 1.6H48a.8.8 0 1 1 0-1.6h29Z"
        fill="#B3C0D0"
      />
      <path
        d="M42.22 47.5c0-.338-.052-.663-.149-.969l-2.52 2.52a.78.78 0 0 1-1.103 0l-1-1a.78.78 0 0 1 1.104-1.103l.448.449 2.223-2.224a3.22 3.22 0 1 0 .997 2.327Zm1.56 0a4.78 4.78 0 1 1-1.454-3.43l1.122-1.122a.78.78 0 0 1 1.104 1.104l-1.29 1.288c.33.649.518 1.382.518 2.16Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.195 70.67a.735.735 0 0 1 .943 0L40 73.176l2.862-2.504a.735.735 0 0 1 .943 0c.26.228.26.596 0 .824L40.943 74l2.862 2.505c.26.228.26.596 0 .824a.735.735 0 0 1-.943 0L40 74.825l-2.862 2.504a.735.735 0 0 1-.943 0 .533.533 0 0 1 0-.824L39.057 74l-2.862-2.505a.533.533 0 0 1 0-.824Z"
        fill="#E41E3F"
      />
      <path
        d="M42.599 70.37a1.135 1.135 0 0 1 1.47 0 .933.933 0 0 1 0 1.427L41.548 74l2.52 2.203a.933.933 0 0 1 0 1.427c-.412.36-1.06.36-1.47 0L40 75.356l-2.599 2.274c-.41.36-1.058.36-1.47 0a.933.933 0 0 1 0-1.427L38.45 74l-2.517-2.203a.933.933 0 0 1 0-1.427 1.135 1.135 0 0 1 1.47 0L40 72.643 42.6 70.37Zm.942.602a.337.337 0 0 0-.416 0L40 73.706l-3.125-2.734a.337.337 0 0 0-.416 0c-.047.04-.059.082-.059.111 0 .029.012.07.059.111L39.664 74l-3.205 2.806c-.047.04-.059.082-.059.111 0 .029.012.07.059.111.11.096.307.096.416 0L40 74.294l3.125 2.734c.11.096.306.096.416 0 .047-.04.059-.082.059-.111 0-.029-.012-.07-.059-.111L40.336 74l3.205-2.806c.047-.04.059-.082.059-.111 0-.029-.012-.07-.059-.111Z"
        fill="#E41E3F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.195 57.671a.735.735 0 0 1 .943 0L40 60.175l2.862-2.504a.735.735 0 0 1 .943 0c.26.228.26.597 0 .825L40.943 61l2.862 2.505c.26.227.26.596 0 .824a.735.735 0 0 1-.943 0L40 61.825l-2.862 2.504a.735.735 0 0 1-.943 0 .533.533 0 0 1 0-.824L39.057 61l-2.862-2.505a.533.533 0 0 1 0-.824Z"
        fill="#E41E3F"
      />
      <path
        d="M42.678 57.307a1.138 1.138 0 0 1 1.39.063l.078.075a.93.93 0 0 1-.078 1.352L41.55 61l2.518 2.203a.933.933 0 0 1 0 1.427c-.41.36-1.058.36-1.47 0L40 62.356l-2.599 2.274c-.41.36-1.058.36-1.47 0a.932.932 0 0 1 0-1.426L38.45 61l-2.517-2.203a.933.933 0 0 1 0-1.427l.08-.063a1.137 1.137 0 0 1 1.39.063L40 59.643l2.599-2.273.079-.063Zm.863.665a.336.336 0 0 0-.415 0L40 60.706l-3.125-2.734a.338.338 0 0 0-.416 0c-.047.04-.059.082-.059.111 0 .029.012.07.059.111L39.664 61l-3.205 2.806c-.047.04-.059.082-.059.111 0 .029.012.07.059.111.11.096.306.096.416 0L40 61.294l3.125 2.734c.11.096.306.096.416 0 .047-.04.059-.082.059-.111 0-.029-.012-.07-.059-.111L40.336 61l3.205-2.806c.047-.04.059-.082.059-.111 0-.029-.012-.07-.059-.111Z"
        fill="#E41E3F"
      />
      <path
        d="m87.607 42.53 18.911 15.767a4.172 4.172 0 1 1-5.59 6.183l-17.59-17.227 4.27-4.723Z"
        fill="#007A5F"
      />
      <path d="m93.55 47.485.561 10.32-10.773-10.552 4.27-4.723 5.943 4.955Z" fill="#00664F" />
      <path
        d="m93.55 47.485.561 10.32-10.773-10.553 4.27-4.722 5.943 4.955Zm-7.995-.3 6.735 6.597-.3-5.514-4.227-3.525-2.208 2.442Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.115 52.322c8.535 4.37 18.998.994 23.368-7.542 4.37-8.535.993-18.998-7.543-23.368-8.536-4.37-18.998-.994-23.368 7.542-4.37 8.536-.993 18.998 7.543 23.368Z"
        fill="#78B441"
      />
      <path
        d="M89.757 37.153c0 6.872-5.571 12.444-12.444 12.444-6.872 0-12.444-5.572-12.444-12.444 0-6.873 5.572-12.444 12.444-12.444 6.873 0 12.444 5.571 12.444 12.444Z"
        fill="#CAE8DF"
      />
      <path
        d="M66.964 37.153c0-5.716 4.633-10.35 10.35-10.35a.8.8 0 1 1 0 1.6 8.75 8.75 0 0 0-8.75 8.75.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M64.07 37.152c0-7.314 5.929-13.242 13.243-13.243a.8.8 0 1 1 0 1.6c-6.43 0-11.644 5.213-11.644 11.643 0 6.431 5.213 11.645 11.644 11.645a.8.8 0 1 1 0 1.6c-7.314 0-13.243-5.93-13.243-13.245Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocError)
